import { render, staticRenderFns } from "./MyEmail.vue?vue&type=template&id=0a05f9a2&"
import script from "./MyEmail.vue?vue&type=script&lang=js&"
export * from "./MyEmail.vue?vue&type=script&lang=js&"
import style0 from "./MyEmail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports